import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('namebryou_were_logged_out'),
    description: defineMessage('you_were_inactive_for_a_ord_to_continue_working'),
    descriptionWithoutPassword: defineMessage('you_were_inactive_for_a_have_locked_your_screen'),
    passwordField: defineMessage('enter_your_password'),
    loginButton: defineMessage('login'),
    twoFaField: defineMessage('enter_factor_authentication_code'),
    twoFaButton: defineMessage('confirm'),
    trustThisDevice: defineMessage('trust_this_device'),
    goToLogin: defineMessage('go_to_login_screen'),
};
